module.exports = __webpack_public_path__ + "images/navigation/refer-smoker-c081f601.jpg";